import sentryPlugin from '@bxs/vue-plugin-sentry'

// const urlWhiteList = [
//   'planBookResult/pages/planbkTemplatev2.html'
// ]

export function initSentry (Vue) {
  // if (!Vue || !urlWhiteList.some(it => window.location.pathname.includes(it))) {
  //   return
  // }

  Vue.use(sentryPlugin, {
    dsn: 'https://d77d93093ba24b85b5b4e43fdc0afb64@sentryv2.winbaoxian.cn/5',
    environment: process.env.NODE_ENV
  })
}
